import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["ReactCompareSlider","ReactCompareSliderImage"] */ "/opt/build/repo/node_modules/react-compare-slider/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/[lang]/docs/[...slug]/document.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/[lang]/not-authorized.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/[lang]/not-found.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/[lang]/richtxt.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/client/ActionBlock/FormatActionBlock.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/client/CognitoForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Datalayer"] */ "/opt/build/repo/src/components/client/Datalayer/Datalayer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/client/DocumentRender.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/client/ImageCarousel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/client/MarketoForm.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/client/SectionTestimonials/FormatSectionTestimonials.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/components/server/SectionStatBlocks/SectionStatBlocks.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/components/server/ImageStrip/ImageStrip.css");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/components/server/ArticleCta/ArticleCta.css");
